import "jquery";
import _, { last } from "lodash";
import "./scores.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Resultados";
let id_selected_season;
let id_selected_round;

//page init
cs_load_last_game();

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

//add filters
let filters = document.createElement("div");
filters.classList.add("row");

let filter_seasons = document.createElement("div");
filter_seasons.classList.add("col-sm-12", "col-md-5", "col-lg-5");

let filter_seasons_title = document.createElement("h3");
filter_seasons_title.innerHTML = "Temporada";
filter_seasons.appendChild(filter_seasons_title);

let filter_rounds = document.createElement("div");
filter_rounds.classList.add("col-sm-12", "col-md-5", "col-lg-5");

let filter_rounds_title = document.createElement("h3");
filter_rounds_title.innerHTML = "Jornada";

filter_rounds.appendChild(filter_rounds_title);

filters.appendChild(filter_seasons);
filters.appendChild(filter_rounds);

let filter_button_container = document.createElement("div");
filter_button_container.classList.add(
  "col-sm-12",
  "col-md-1",
  "col-lg-1",
  "d-flex",
  "justify-content-center"
);
let filter_button = document.createElement("button");
filter_button.classList.add("btn", "btn-primary", "h-50");
filter_button.style.marginTop = "2.5rem";
filter_button.style.backgroundColor = "#e4002B";
filter_button.innerHTML = "Buscar";
filter_button.addEventListener("click", () => {
  showScoresTable(scores_list_table);
});

filter_button_container.appendChild(filter_button);

filters.appendChild(filter_button_container);

page_template_content.appendChild(filters);

//add table list

let scores_list = document.createElement("div");
scores_list.classList.add("row");

let scores_list_table = document.createElement("div");
scores_list_table.classList.add("col-sm-12", "col-md-12", "col-lg-12");

scores_list.appendChild(scores_list_table);

page_template_content.appendChild(scores_list_table);

showScoresTable(scores_list_table);

//populate the selectes and send the score_list_table to refres
showSeasons(filter_seasons, scores_list_table, filter_rounds);
showRounds(filter_rounds, scores_list_table);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/

//dom manipulation
async function showRounds(container, scores_list_table) {
  container.innerHTML = "";
  let filter_rounds_title = document.createElement("h3");
  filter_rounds_title.innerHTML = "Jornada";

  filter_rounds.appendChild(filter_rounds_title);

  var select_rounds = document.createElement("select");

  let rounds_response = await getRounds().then((roundsItems) => {
    select_rounds.classList.add("select");

    let round_founded = false;
    let last_round_id = null;
    let first_value = null;

    if (roundsItems.items.length > 0) {
      $.each(roundsItems.items, function (item) {
        let option = document.createElement("option");
        option.value = this.id;
        option.text = this.name;
        if (this.id == id_selected_round) {
          option.selected = true;
          round_founded = true;
        }
        if (first_value == null) {
          last_round_id = this.id;
          first_value = true;
        }
        select_rounds.add(option);
      });

      if (!round_founded) {
        // console.log(
        //   "round_founded",
        //   round_founded + "last_round_id",
        //   last_round_id
        // );
        id_selected_round = last_round_id;
      }
    }
    // console.log("rouind_founded", round_founded);
    return select_rounds;
  });

  select_rounds.addEventListener(
    "change",
    (ele) => {
      id_selected_round = ele.target.value;
      //load tables with the selected data
      // showScoresTable(scores_list_table);
    },
    true
  );

  container.appendChild(rounds_response);
}

async function showSeasons(container, scores_list_table, filter_rounds) {
  var select_seasons = document.createElement("select");

  let season_response = await getSeasons().then((seasonItems) => {
    select_seasons.classList.add("select");
    select_seasons.id = "season";

    if (seasonItems.items.length > 0) {
      $.each(seasonItems.items, function (index) {
        let option = document.createElement("option");
        option.value = this.id;
        option.text = this.name;
        if (this.id == id_selected_season) {
          option.selected = true;
        }
        select_seasons.add(option);
      });
    }
    return select_seasons;
  });

  select_seasons.addEventListener(
    "change",
    (ele) => {
      cs_load_last_game();
      id_selected_season = ele.target.value;
      //load tables with the selected data
      showRounds(filter_rounds, scores_list_table);
      // showScoresTable(scores_list_table);
    },
    true
  );

  container.appendChild(season_response);
}

async function showScoresTable(container) {
  container.innerHTML = "";

  let table_data = await getScoreList().then((response) => {
    let table = document.createElement("table");
    table.classList.add("text-center", "score_table");

    if (response.items.length > 0) {
      response.items.forEach((item) => {
        let table_row = document.createElement("tr");

        let table_team_1_logo = document.createElement("td");

        let team_1_logo = document.createElement("img");
        team_1_logo.src = base_url + item.team_1.full_url_logo;
        team_1_logo.classList.add("score_table_img");
        table_team_1_logo.appendChild(team_1_logo);

        let table_team_1 = document.createElement("td");
        table_team_1.innerHTML = item.participant_a;

        let table_team_1_score = document.createElement("td");
        table_team_1_score.innerHTML = item.score_1;

        let table_vs = document.createElement("td");
        table_vs.innerHTML = "VS";

        let table_team_2 = document.createElement("td");
        table_team_2.innerHTML = item.participant_b;

        let table_team_2_score = document.createElement("td");
        table_team_2_score.innerHTML = item.score_2;

        let table_team_2_logo = document.createElement("td");
        let team_2_logo = document.createElement("img");
        team_2_logo.src = base_url + item.team_2.full_url_logo;
        team_2_logo.classList.add("score_table_img");
        table_team_2_logo.appendChild(team_2_logo);

        table_row.appendChild(table_team_1_logo);
        table_row.appendChild(table_team_1);
        table_row.appendChild(table_team_1_score);
        table_row.appendChild(table_vs);
        table_row.appendChild(table_team_2);
        table_row.appendChild(table_team_2_score);
        table_row.appendChild(table_team_2_logo);

        //create row for video
        let table_row_video = document.createElement("tr");
        table_row_video.style.display = "none";
        let table_row_video_td = document.createElement("td");

        table_row_video.appendChild(table_row_video_td);

        table.appendChild(table_row);
      });
    } else {
      let table_row = document.createElement("tr");
      let table_row_td = document.createElement("td");
      table_row_td.style.textAlign = "center";
      table_row_td.innerHTML = "No hay resultados";
      table_row.appendChild(table_row_td);
      table.appendChild(table_row);
    }

    return table;
  });

  container.appendChild(table_data);
}

//loads video for specific game
// async function showScoreTableDetail(id_game, container) {
//   //"
//   // <li class='cs_item cs_score_videos'>
//   //   <a href='videos.html?id=|ID|'>
//   //     <div class='cs_video_icon'>
//   //       <img src='|THUMBNAIL|'>
//   //     </div>
//   //     <div>
//   //       <span>|NAME|</span>
//   //       </div>
//   //   </a>
//   // </li>"

//   let table_data = await getScoreDetail(id_game).then((response) => {
//     console.log("showScoreTableDetail is", response);

//     let item = response.item;

//     if(item.url_live != "" || item.url_live != undefined) {
//       let video_li = document.createElement("li");
//       let video_a = document.createElement("a");
//       video_a.src = `videos.html?id=${item.id}`;
//       video_li.appendChild(video_a);

//       let video_thumbnail_container = document.createElement("div");
//       let video_thumbnail = document.createElement("img");

//       video_thumbnail_container.appendChild(video_thumbnail);
//       video_a.appendChild(video_thumbnail_container);

//       let video_name_container = document.createElement("div");
//       let video_name = document.createElement("span");
//       video_a.appendChild(video_name_container);

//       video_name.innerHTML = item.name;
//       video_name_container.appendChild(video_name);

//       return video_li;
//     }else{
//       let no_video_li = document.createElement("li");
//       no_video_li.classList.add("cs_item","cs_score_videos", "cs_message");
//       let no_video_span = document.createElement("span");
//       no_video_li.appendChild(no_video_span);

//       no_video_span.innerHTML = "No hay videos.";
//       // $(showScoreTableDetail).append("<li class='cs_item cs_score_videos cs_message'><span>No hay videos.</span></li>");
//       return no_video_li;
//     }
//   });

//   console.log("this is table_data", table_data);

//   container.appendChild(table_data);
//       // if(response.item.videos.length > 0) {
//       //     $.each(response.item.videos, function(i, item) {
//       //         //Set the thumbnail.
//       //         var url = "";

//       //         if (item.url.indexOf("facebook") > -1) {
//       //             //Get the video id.
//       //             var split_url = item.url.split("/");
//       //             var facebook_id = "";

//       //             while (facebook_id === "") {
//       //                 facebook_id = split_url.pop();
//       //             }

//       //             url = "https://graph.facebook.com/" + facebook_id + "/picture";
//       //         } else {
//       //             url = "https://img.youtube.com/vi/" + item.url + "/default.jpg";
//       //         }

//       //         $("#score_" + id).append(
//       //             template_item_videos
//       //             .replace(/\|ID\|/g, item.id)
//       //             .replace(/\|THUMBNAIL\|/g, url)
//       //             .replace(/\|NAME\|/g, item.name)
//       //         );
//       //     });
//       // } else {
//       //     $("#score_" + id).append("<li class='cs_item cs_score_videos cs_message'><span>No hay videos.</span></li>");
//       // }
// }

//ajax calls
//crea el select para la temporada
async function getSeasons() {
  var ajax_data = {};
  return $.ajax({
    type: "POST",
    url: base_url + "/sports/seasons/all",
    data: ajax_data
  });
}

//crea el select para las jornadas
async function getRounds() {
  var ajax_data = {
    id_season: id_selected_season
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/rounds/season",
    data: ajax_data
  });
}

//loads all games
async function getScoreList() {
  //Prepare the request data.
  var ajax_data = {
    id_round: id_selected_round,
    played: true,
    with: ["team_1", "team_2", "round"]
  };

  return $.ajax({
    type: "POST",
    url: base_url + "/sports/games/filtered",
    data: ajax_data
  });
}

//loads video for specific game
// async function getScoreDetail(id) {
//   //Prepare the request data.
//   var ajax_data = {
//     id: id,
//   };

//   return $.ajax({
//     type: "POST",
//     url: base_url + "/sports/games/single",
//     data: ajax_data,
//     async: false,
//   });
// }

function cs_load_last_game() {
  var ajax_data = {};

  $.ajax({
    type: "POST",
    url: base_url + "/sports/games/last",
    data: ajax_data,
    async: false
  }).done(function (response) {
    id_selected_season = response.item[0].round.id_season;
    id_selected_round = response.item[0].round.id;
  });
}
